import React from "react";

import fronteraIcon from "../../../assets/icon.png";

interface LogoLoaderProps {
  // Called once the loader has shown for its minimum duration.
  onDone: () => void;
  durationMs?: number;
}

// Full-screen branded loader shown immediately after sign-up while the account
// is being prepared. Auto-advances to the first onboarding step after a short
// beat. Matches Figma frame 204:82 (centered Frontera logo only).
export const LogoLoader: React.FC<LogoLoaderProps> = ({ onDone, durationMs = 2000 }) => {
  // Keep `onDone` in a ref so the auto-advance timer is scheduled once and isn't
  // reset by parent re-renders that pass a new inline callback each time.
  const onDoneRef = React.useRef(onDone);
  React.useEffect(() => {
    onDoneRef.current = onDone;
  }, [onDone]);

  React.useEffect(() => {
    const timer = setTimeout(() => onDoneRef.current(), durationMs);
    return () => clearTimeout(timer);
  }, [durationMs]);

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-white">
      <img src={fronteraIcon} alt="Frontera" className="animate-logo-pulse h-16 w-16" />
    </div>
  );
};
